module.exports = __webpack_public_path__ + "fonts/futura-t-light.201ad073.ttf";